import { IEmployeeDTO, IEmployeeViewDTO } from "../../../libs/coreapi-dto/dirs/employee";
import renderGlobalAlert from "../../../system/hooks/useGlobalAlert";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


interface IEmployeeCreate extends IEmployeeDTO {
}
interface IEmployeeUpdate extends IEmployeeDTO{
}

class EmployeeRequest extends BaseDirRequest<IEmployeeViewDTO, IEmployeeDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "employee", token, eventHandler)
    }

    getView(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IEmployeeViewDTO>>) => void) {
        this.post<IViewWrapper<IEmployeeViewDTO>>(`${this._baseUrl}/${this._routePrefix}/view`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    create(body: IEmployeeCreate, callback: (e:CoreApiResponse<string>)=>void){
        super.create(body,callback)
    }

    update(idGlobal:string, body: IEmployeeUpdate, callback: (e:CoreApiResponse<null>)=>void){
        super.update(idGlobal,body,callback)
    }
    

    getById(id: string, callback?: (e: CoreApiResponse<IEmployeeDTO>) => void) {
        this.get<IEmployeeDTO>(`${this._baseUrl}/${this._routePrefix}/${id}`, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    if (e.message?.statusCode === 404) {
                        renderGlobalAlert({
                            variant: "warning",
                            title: "Employee: Not Found",
                            statusCode: 404
                        });
                    }
                } else {
                    callback?.(e);
                }
            }
        })
    }

    deleteById(id: string, update: () => void) {
        this.delete(`${this._baseUrl}/${this._routePrefix}/${id}`, {}, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), e => {
            update();
        })
    }

    restore(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Restore`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }
}

export default EmployeeRequest